export default __webpack_public_path__ + "static/media/solarGoApp.01e7542c.png";